import React from 'react';
import { Container, ContainerTopGrahps, ContainerBottomGrahps, ContentGraphics, CustomTitleGraphics } from './style';
import { CardGraphic } from '../CardGraphic';
import { ComponentNoDataCharts } from '../NoDataGraphic';
import { MenuItem, FormControl, Grid } from '@mui/material';
import { CustomSelectDemo } from '../../pages/styles';
import { useTranslation } from 'react-i18next';

const colors = [
    '#10476b', '#b6b310', '#DC4E4E', '#862D9C', '#FFA500', '#2FE38F', '#F0F0F0',
    '#502513', '#00BFFF', '#FF63B1', '#228B22', '#FFD700', '#138fb4', '#11a0a0',
    '#0c8a9d', '#0d7b88', '#92a611', '#a9b211', '#838e13', '#6b7b14'
];

export const GraphicNewGeneralReport = ({ filters, chartRef, graphicDonutUp, graphicCritical, graphicHistorical, graphicHistoricalCritical, graphicColdHot, handleChangeHistorical }) => {

    const { t } = useTranslation();

    const optionsDonut = {
    chart: { type: 'donut' },
    colors: colors,
    legend: { show: false },
    dataLabels: {
        enabled: true,
        formatter: function (val, { seriesIndex, w }) {
            return w.config.labels[seriesIndex];
        }
    },
    plotOptions: {
        pie: {
            donut: {
                labels: {
                    show: true,
                    total: {
                        show: true,
                        showAlways: true,
                        fontSize: '16px',
                        fontWeight: 600,
                        color: '#333',
                        label: t("dashboard.graphics.generalReport.total"),
                        formatter: function (w) {
                            const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                            return total;
                        }
                    }
                }
            }
        }
    }
};


    const optionsBar = {
    chart: {
      type: 'bar',
      stacked: true,
      toolbar: {
        show: false
      }
    },
    colors: [
      '#10476b', '#0778a6', '#b6b310', '#145f89', '#105b73', '#0b4b7a', '#0d5b8c',
      '#125f83', '#095f76', '#066d8a', '#1c6b96', '#1173a0', '#138fb4', '#11a0a0',
      '#0c8a9d', '#0d7b88', '#92a611', '#a9b211', '#838e13', '#6b7b14'
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      style: {
        fontSize: '13px',
        fontWeight: 600,
        colors: ['#000']
      },
      formatter: function (val, { seriesIndex, dataPointIndex, w }) {
        const allSeries = w.globals.series;
        const total = allSeries.reduce((sum, serie) => sum + (serie[dataPointIndex] || 0), 0);
        const isLast = seriesIndex === allSeries.length - 1;
        return isLast ? total : '';
      }
    },
    xaxis: {
      categories: [t("dashboard.graphics.generalReport.cold"), t("dashboard.graphics.generalReport.hot")]
    },
    legend: {
      show: true,
      position: 'left',
      offsetY: 40,
    }
  };
  

    const chartKeys = {
        [t("dashboard.graphics.generalReport.inscription")]: 'inscription',
        [t("dashboard.graphics.generalReport.planning")]: 'programming',
        [t("dashboard.graphics.generalReport.execution")]: 'execution',
        [t("dashboard.graphics.generalReport.suspension")]: 'suspension',
        [t("dashboard.graphics.generalReport.closure")]: 'closure'
    };

    const months = [
        t("dashboard.graphics.generalReport.months.1"), t("dashboard.graphics.generalReport.months.2"), t("dashboard.graphics.generalReport.months.3"),
        t("dashboard.graphics.generalReport.months.4"), t("dashboard.graphics.generalReport.months.5"), t("dashboard.graphics.generalReport.months.6"),
        t("dashboard.graphics.generalReport.months.7"), t("dashboard.graphics.generalReport.months.8"), t("dashboard.graphics.generalReport.months.9"),
        t("dashboard.graphics.generalReport.months.10"), t("dashboard.graphics.generalReport.months.11"), t("dashboard.graphics.generalReport.months.12")
    ];

    const years = [
        new Date().getFullYear() - 2,
        new Date().getFullYear() - 1,
        new Date().getFullYear()
    ];

    return (
        <Container>
            <ContainerTopGrahps>
                {Object.entries(chartKeys).map(([title, key]) => {
                    const chartData = graphicDonutUp[key] || { labels: [], series: [] };
                    const total = chartData.series.reduce((acc, val) => acc + val, 0);

                    return (
                        <ContentGraphics key={key} width={'20%'}>
                            <CustomTitleGraphics>{title}</CustomTitleGraphics>
                            {chartData.series?.some(el => el > 0) ? (
                                <CardGraphic
                                    type="donut"
                                    options={{
                                        ...optionsDonut,
                                        labels: chartData.labels,
                                        tooltip: {
                                            ...optionsDonut.tooltip,
                                            y: {
                                                formatter: function (value) {
                                                    const percentage = total > 0 ? ((value / total) * 100).toFixed(0) : 0;
                                                    return `${value} (${percentage}%)`;
                                                }
                                            }
                                        }
                                    }}
                                    series={chartData.series}
                                    chartRef={chartRef}
                                />
                            ) : (
                                <ComponentNoDataCharts isFlow={false} height={'100%'} />
                            )}
                        </ContentGraphics>
                    );
                })}
            </ContainerTopGrahps>


            <ContainerBottomGrahps>
                <ContentGraphics width="25%">
                    <CustomTitleGraphics>{t("dashboard.graphics.generalReport.criticalActivitiesPermits")}</CustomTitleGraphics>
                    {graphicCritical.series?.some(el => el > 0) ? (() => {
                        const total = graphicCritical.series.reduce((acc, val) => acc + val, 0);

                        return (
                            <CardGraphic
                                type="donut"
                                options={{
                                    ...optionsDonut,
                                    labels: graphicCritical.labels ?? [],
                                    tooltip: {
                                        ...optionsDonut.tooltip,
                                        y: {
                                            formatter: function (value) {
                                                const percentage = total > 0 ? ((value / total) * 100).toFixed(0) : 0;
                                                return `${value} (${percentage}%)`;
                                            }
                                        }
                                    },
                                    legend: {
                                        show: true,
                                        position: 'bottom',
                                        offsetY: 0,
                                    }
                                }}
                                series={graphicCritical.series ?? []}
                                chartRef={chartRef}
                            />
                        )
                    })() : (
                        <ComponentNoDataCharts isFlow={false} height={'100%'} />
                    )}
                </ContentGraphics>


                <ContentGraphics width="25%">
                    <CustomTitleGraphics>{t("dashboard.graphics.generalReport.coldHotElectric")}</CustomTitleGraphics>
                    {graphicColdHot.series?.some(serie => serie.data.some(value => value > 0)) ? (
                        <CardGraphic
                            type="bar"
                            options={{
                                ...optionsBar,
                                xaxis: { categories: graphicColdHot.categories ?? [] },
                                legend: {
                                  show: true,
                                  position: 'bottom',
                                  itemMargin: { vertical: 2 }
                                }
                            }}
                            series={graphicColdHot.series ?? []}
                            chartRef={chartRef}
                        />
                    ) : (
                        <ComponentNoDataCharts isFlow={false} height={'100%'} />
                    )}
                </ContentGraphics>
                
                <ContentGraphics width="25%">
                    <Grid container spacing={1}>
                        <Grid item xs={5}>
                          <CustomTitleGraphics>{t("dashboard.graphics.generalReport.historicalCriticalActivities")}</CustomTitleGraphics>
                        </Grid>

                        <Grid item xs={3.5}>
                          <FormControl fullWidth>
                              <CustomSelectDemo
                                  value={filters.year}
                                  onChange={(e) => handleChangeHistorical(e.target.value, 'year', 'critical')}
                                  displayEmpty
                              >
                                  <MenuItem value="" disabled>
                                      {t("dashboard.graphics.generalReport.year")}
                                  </MenuItem>
                                  {years.map((year, index) => (
                                      <MenuItem key={index} value={year}>{year}</MenuItem>
                                  ))}
                              </CustomSelectDemo>
                          </FormControl>
                        </Grid>

                        <Grid item xs={3.5}>
                          <FormControl fullWidth>
                            <CustomSelectDemo
                                value={filters.month}
                                onChange={(e) => handleChangeHistorical(e.target.value, 'month', 'critical')}
                                displayEmpty
                            >
                                <MenuItem value=''>
                                    -
                                </MenuItem>
                                {months.map((month, index) => (
                                    <MenuItem key={`${month} - ${index + 1}`} value={index + 1}>{month}</MenuItem>
                                ))}
                            </CustomSelectDemo>
                          </FormControl>
                        </Grid>
                    </Grid>
                    {graphicHistoricalCritical.series?.some(el => el > 0) ? (() => {
                        const total = graphicHistoricalCritical.series.reduce((acc, val) => acc + val, 0);

                        return (
                            <CardGraphic
                                type="donut"
                                options={{
                                    ...optionsDonut,
                                    labels: graphicHistoricalCritical.labels ?? [],
                                    tooltip: {
                                        ...optionsDonut.tooltip,
                                        y: {
                                            formatter: function (value) {
                                                const percentage = total > 0 ? ((value / total) * 100).toFixed(0) : 0;
                                                return `${value} (${percentage}%)`;
                                            }
                                        }
                                    },
                                    legend: {
                                        show: true,
                                        position: 'bottom',
                                        offsetY: 0,
                                    }
                                }}
                                series={graphicHistoricalCritical.series ?? []}
                                chartRef={chartRef}
                            />
                        )
                    })() : (
                        <ComponentNoDataCharts isFlow={false} height={'100%'} />
                    )}
                </ContentGraphics>


                <ContentGraphics width="25%">
                    <Grid container spacing={1}>
                        <Grid item xs={5}>
                            <CustomTitleGraphics>{t("dashboard.graphics.generalReport.historicalRiskLevel")}</CustomTitleGraphics>
                        </Grid>

                        <Grid item xs={3.5}>
                          <FormControl fullWidth>
                              <CustomSelectDemo
                                  value={filters.year}
                                  onChange={(e) => handleChangeHistorical(e.target.value, 'year', 'risk')}
                                  displayEmpty
                              >
                                  <MenuItem value="" disabled>
                                      {t("dashboard.graphics.generalReport.year")}
                                  </MenuItem>
                                  {years.map((year, index) => (
                                      <MenuItem key={index} value={year}>{year}</MenuItem>
                                  ))}
                              </CustomSelectDemo>
                          </FormControl>
                        </Grid>

                        <Grid item xs={3.5}>
                          <FormControl fullWidth>
                              <CustomSelectDemo
                                  value={filters.month}
                                  onChange={(e) => handleChangeHistorical(e.target.value, 'month', 'risk')}
                                  displayEmpty
                                  MenuProps={{
                                      PaperProps: {
                                          style: {
                                              maxHeight: 200,
                                              overflowY: "auto"
                                          }
                                      }
                                  }}
                              >
                                  <MenuItem value=''>
                                      -
                                  </MenuItem>
                                  {months.map((month, index) => (
                                      <MenuItem key={`${month} - ${index + 1}`} value={index + 1}>{month}</MenuItem>
                                  ))}
                              </CustomSelectDemo>
                          </FormControl>
                        </Grid>
                    </Grid>
                    {graphicHistorical.series?.some(el => el > 0) ? (() => {
                        const total = graphicHistorical.series.reduce((acc, val) => acc + val, 0);

                        return (
                            <CardGraphic
                                type="donut"
                                options={{
                                    ...optionsDonut,
                                    labels: graphicHistorical.labels ?? [],
                                    tooltip: {
                                        ...optionsDonut.tooltip,
                                        y: {
                                            formatter: function (value) {
                                                const percentage = total > 0 ? ((value / total) * 100).toFixed(0) : 0;
                                                return `${value} (${percentage}%)`;
                                            }
                                        }
                                    }
                                }}
                                series={graphicHistorical.series ?? []}
                                chartRef={chartRef}
                            />
                        )
                    })() : (
                        <ComponentNoDataCharts isFlow={false} height={'100%'} />
                    )}
                </ContentGraphics>
            </ContainerBottomGrahps>
        </Container>
    );
};
